import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  HostListener,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location, isPlatformBrowser } from '@angular/common';
import { CampaignService } from '../../../core/services/api/campaign.service';
import { ErrorService } from '../../../core/services/error.service';
import { finalize, share } from 'rxjs/operators';
import { InvestmentModel } from '../../../core/models/investment/investment.model';
import { DefaultProfileImage } from '../../../core/services/constant';
import { InvestmentStatus } from '../../../core/enum/investment-status.enum';
import { ReferralCode, ReferralCodeText } from '../../../core/enum/referral-code.enum';
import { Campaign } from '../../../core/models/campaign/campaign';
import { CsvService } from '../../../core/services/csv.service';
import { FieldKey } from '../../../core/models/share/field-key';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { BlockUiService } from '../../../shared/services/blockUi/block-ui.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SortDirection } from '../../../core/enum/sort-direction.enum';
import { ShareType } from '../../../core/enum/share-type.enum';
import { CampaignStatus } from '../../../core/enum/campaign-status.enum';
import { PaymentTo } from '../../../core/enum/payment-to-type.enum';
import { ShareAllotmentStatus } from '../../../core/enum/share-allotment-status.enum';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService } from '../../../core/services/storage.service';
import { Role } from '../../../core/enum/role.enum';
import { ReviewStatus } from '../../../core/enum/share-review-status.enum';
import { ShareReviewEditPopupComponent } from './share-review-edit-popup/share-review-edit-popup.component';
import { ToastService } from '../../../core/services/toast.service';
@Component({
    selector: 'app-investor-management-list',
    templateUrl: './investor-management-list.component.html',
    styleUrls: ['./investor-management-list.component.scss'],
    standalone: false
})
export class InvestorManagementListComponent implements OnInit {
  @Input() campaign: Campaign;
  @Input() finalSubmitted: boolean = false;

  @Output() onInvestorListLoaded = new EventEmitter();
  @Output() reviewStatusUpdated = new EventEmitter<void>();

  isPage: boolean = false;
  slug: string;
  campaignTitle: string;
  investments: InvestmentModel[];
  params = {
    currentPage: 1,
    take: 20, // Default for desktop
    sortBy: 'createdAt',
    sortDirection: SortDirection.Desc,
    status: '',
    referralCode: '',
    Types: '',
    PaymentTo: '',
    InvestorName: '',
    ReviewStatus: '',
  };

  isMobile: boolean = false;

  isLoading: boolean = true;
  isInvitedToInvest: boolean = true;

  total: number = 0;
  defaultProfileImage = DefaultProfileImage;
  ShareType = ShareType;
  InvestmentStatus = InvestmentStatus;
  ReviewStatus = ReviewStatus;
  PaymentTo = PaymentTo;
  Role = Role;
  investmentStatusEntries: { key: number; value: string }[] = [];
  ReviewStatusEntries: { key: number; value: string }[] = [];
  ShareTypeEntries: { key: number; value: string }[] = [];
  SortDirection = SortDirection; // Expose SortDirection to the template
  isNaN = isNaN; // Expose isNaN to the template
  isMultiShareType: boolean = false;
  isfilterstatuschanged: boolean = false;
  isFilterReviewStatusChanged: boolean = false;
  isfiltersharetypechanged: boolean = false;
  ReferralCode = ReferralCode;
  referralCodeEntries: { key: number; value: string }[] = [];
  isfilterreferralCodechanged: boolean = false;
  hasReferralCodes: boolean = false;
  selectedPaymentType: string = '0';
  selectedRefferal: string = '0';
  currentitem: number = 0;
  currentlastitem: number = 0;
  searchName: string = '';
  copiedCode: string | null = null;
  private approvingShareReviewIds = new Set<number>();
  private selectedShareReviewIds = new Set<number>();
  bulkApprovingShareReview: boolean = false;

  sortby: string;
  sortdirection: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private campaignService: CampaignService,
    private errorService: ErrorService,
    private csvService: CsvService,
    private translateService: TranslateService,
    private blockUiService: BlockUiService,
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platform: Object,
    private snackBar: MatSnackBar,
    private toastService: ToastService,
    public storageService: StorageService,
  ) {}

  ngOnInit() {
    console.log('ngOnInit called. Initial isLoading:', this.isLoading);

    // Check if device is mobile
    this.checkDeviceType();
    if (!this.campaign?.id) {
      this.isPage = true;
      this.slug = this.activatedRoute.snapshot.params.slug;
      this.getCampaign();
      return;
    }
    this.checkismultisharetype();
    // Populate investment status entries for the dropdown
    this.populateShareTypeStatusEntries();
    // Populate investment status entries for the dropdown
    this.populateInvestmentStatusEntries();
    this.populateReviewStatusEntries();
    this.populateReferralCodeEntries();
    // Set initial state to all selected
    this.selectedStatuses = this.investmentStatusEntries.map((s) => s.key);
    this.selectedReviewStatuses = this.ReviewStatusEntries.map((s) => s.key);
    this.getCampaignInvestorList();
  }

  populateInvestmentStatusEntries() {
    // Convert enum to array of key-value pairs for easier iteration in template
    this.investmentStatusEntries = Object.keys(InvestmentStatus)
      .filter((key) => !isNaN(Number(key)))
      .map((key) => ({
        key: Number(key),
        value: InvestmentStatus[key],
      }));
    this.investmentStatusEntries = this.investmentStatusEntries.filter(
      (item) => item.key !== InvestmentStatus.Cancelled,
    );
    this.investmentStatusEntries = this.investmentStatusEntries.filter(
      (item) => item.key !== InvestmentStatus.PledgeCancelled,
    );
    this.investmentStatusEntries = this.investmentStatusEntries.filter(
      (item) => item.key !== InvestmentStatus.None,
    );
    const customStatusorder = [1, 6, 2, 5, 4, 7];
    //const customStatusorder=[InvestmentStatus.PendingPayment,InvestmentStatus.PaymentApprovalPending,InvestmentStatus.Paid,InvestmentStatus.RefundRequested,InvestmentStatus.Refunded,InvestmentStatus.Completed]
    this.investmentStatusEntries = this.investmentStatusEntries.sort(
      (a, b) => customStatusorder.indexOf(a.key) - customStatusorder.indexOf(b.key),
    );

    console.log('Investment status entries:', this.investmentStatusEntries);
  }
  populateReviewStatusEntries() {
    // Convert enum to array of key-value pairs for easier iteration in template
    this.ReviewStatusEntries = Object.keys(ReviewStatus)
      .filter((key) => !isNaN(Number(key)))
      .map((key) => ({
        key: Number(key),
        value: ReviewStatus[key],
      }));
    this.ReviewStatusEntries = this.ReviewStatusEntries.filter(
      (item) => item.key !== ReviewStatus.None,
    );
    console.log('Share review status entries:', this.ReviewStatusEntries);
  }

  populateShareTypeStatusEntries() {
    // Convert enum to array of key-value pairs for easier iteration in template

    for (const element of this.campaign.shareTypes) {
      this.ShareTypeEntries.push({
        key: element,
        value: ShareType[element],
      });
    }
  }

  IsStatusFilterEnable(): boolean {
    let isEnabled = false;
    if (
      this.campaign.campaignStatus == CampaignStatus.PreLive ||
      this.campaign.campaignStatus == CampaignStatus.Live ||
      this.campaign.campaignStatus == CampaignStatus.Cooling ||
      this.campaign.campaignStatus == CampaignStatus.ShareAllotment
    ) {
      isEnabled = true;
    }
    return isEnabled;
  }
  IsshareallotmentStatusFilterEnable(): boolean {
    let isEnabled = true;
    if (
      this.campaign.campaignStatus == CampaignStatus.PreLive ||
      this.campaign.campaignStatus == CampaignStatus.Live ||
      this.campaign.campaignStatus == CampaignStatus.Cooling
    ) {
      isEnabled = false;
    }
    return isEnabled;
  }

  checkismultisharetype() {
    console.log('this.campaign.shareTypes.length:', this.campaign.shareTypes.length);
    if (this.campaign.shareTypes.length <= 1) {
      this.isMultiShareType = false;
      console.log('isMultiShareType:', this.isMultiShareType);
    } else {
      this.isMultiShareType = true;
      console.log('isMultiShareType:', this.isMultiShareType);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkDeviceType();
    // Reload the list with new page size if we're already displaying data
    if (this.investments && this.investments.length > 0) {
      // Reset to first page when changing device type to avoid pagination issues
      this.params.currentPage = 1;
      this.getCampaignInvestorList();
    }
  }

  checkDeviceType() {
    // Check if screen width is less than 768px (standard mobile breakpoint)
    if (isPlatformBrowser(this.platform)) {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 800;

      // Only update take parameter if the device type has changed
      if (wasMobile !== this.isMobile) {
        this.params.take = this.isMobile ? 10 : 20; // 10 records for mobile, 20 for desktop
        console.log(
          'Device type changed to:',
          this.isMobile ? 'mobile' : 'desktop',
          'Records per page:',
          this.params.take,
        );
      }
    }
  }

  formatInvestorName(fullName?: string | null): string {
    if (!fullName) return '';

    const normalized = fullName.trim().replace(/\s+/g, ' ');
    const words = normalized.split(' ').map((word) => {
      const lower = word.toLowerCase();
      if (lower === 'a/l') return 'A/L';
      if (lower === 'a/p') return 'A/P';
      return lower.replace(/(^[a-z])|([-'][a-z])/g, (m) => m.toUpperCase());
    });

    return words
      .join(' ')
      .replace(/(^|\s)a\/l(?=\s|$|[.,;:)\]])/gi, '$1A/L')
      .replace(/(^|\s)a\/p(?=\s|$|[.,;:)\]])/gi, '$1A/P');
  }

  /**
   * Builds the filter parameters object for API requests
   * Consolidates logic for constructing query params to reduce duplication
   */
  private buildInvestorListRequestParams() {
    return {
      status: this.params.status,
      Types: this.params.Types,
      referralCode: this.params.referralCode,
      PaymentTo: this.params.PaymentTo,
      InvestorName: this.params.InvestorName,
      ReviewStatus: this.params.ReviewStatus,
    };
  }

  getCampaign() {
    console.log('getCampaign started.');
    this.campaignService.getCampaign(this.slug).subscribe({
      next: (data) => {
        this.campaign = data;
        console.log(
          'API Response Processed. campaign.isCreator:',
          this.campaign?.isCreator,
          'isInvitedToInvest should be true',
        );
        console.log('isPlatformBrowser:', isPlatformBrowser(this.platform));

        // Avoid the list being ssr-ed
        if (isPlatformBrowser(this.platform)) {
          console.log('Platform is browser.');
          if (!data?.isCreator && data?.isPrivate && !data?.isInvited) {
            this.isInvitedToInvest = false;
            this.isLoading = false;
            console.log(
              'INVITE ONLY BLOCK EXECUTED (should not happen for creator). isLoading:',
              this.isLoading,
            );
            return;
          }
          console.log(
            'Calling getCampaignInvestorList from getCampaign. Current isLoading before call:',
            this.isLoading,
          );

          this.checkismultisharetype();
          // Populate investment status entries for the dropdown
          this.populateShareTypeStatusEntries();
          // Populate investment status entries for the dropdown
          this.populateInvestmentStatusEntries();
          this.populateReferralCodeEntries();
          this.populateReviewStatusEntries();
          // Set initial state to all selected
          this.selectedStatuses = this.investmentStatusEntries.map((s) => s.key);
          this.getCampaignInvestorList();
        } else {
          console.log('Platform is NOT browser.');
        }
      },
      error: (err) => {
        this.errorService.showError(err);
        this.isLoading = false;
        console.error('Error in getCampaign. isLoading:', this.isLoading, err);
      },
    });
  }

  getCampaignInvestorList(isReport: boolean = false) {
    console.log('getCampaignInvestorList called. isReport:', isReport);

    if (isReport) this.blockUiService.open();
    else {
      this.isLoading = true;
      console.log('isLoading set to true in getCampaignInvestorList.');
    }

    // Build filter parameters from this.params to reduce duplication
    const filterParams = this.buildInvestorListRequestParams();

    const useShareholderListApi = this.shouldUseShareholderListApi();
    const sortByForRequest = this.params.sortBy;

    const request$ = useShareholderListApi
      ? this.campaignService.getCampaignShareholderList(
          this.campaign.id,
          this.params.currentPage,
          this.params.take,
          isReport,
          sortByForRequest,
          this.params.sortDirection,
          filterParams.status,
          filterParams.Types,
          filterParams.referralCode,
          filterParams.PaymentTo,
          filterParams.InvestorName,
          filterParams.ReviewStatus,
        )
      : this.campaignService.getCampaignInvestorsList(
          this.campaign.id,
          this.params.currentPage,
          this.params.take,
          isReport,
          sortByForRequest,
          this.params.sortDirection,
          filterParams.status,
          filterParams.Types,
          filterParams.referralCode,
          filterParams.PaymentTo,
          filterParams.InvestorName,
          filterParams.ReviewStatus,
        );

    request$
      .pipe(
        finalize(() => {
          if (isReport) this.blockUiService.close();
          else {
            this.isLoading = false;
            console.log('FINALIZED getCampaignInvestorList. isLoading set to false.');
          }
        }),
      )
      .subscribe({
        next: (data) => {
          console.log('getCampaignInvestorList success.');
          if (!isReport) {
            this.investments = data.data;
            this.total = data.total;
            this.currentitem = (this.params.currentPage - 1) * this.params.take + 1;
            if (this.params.currentPage * this.params.take > this.total) {
              this.currentlastitem = this.total;
            } else {
              this.currentlastitem = this.params.currentPage * this.params.take;
            }
            this.hasReferralCodes = this.investments.some((inv) => inv.hasReferralCode);
            this.clearReviewSelection();
          } else {
            let jsonData = data.data.map((item) => {
              return {
                fullName: this.formatInvestorName(item.user?.fullName) || item.user?.fullName || '',
                investorType: item.isNominee ? 'Nominees' : 'Direct Investor',
                createdAt: moment(item.createdAt).format('D MMM YYYY'),
                shareType: ShareType[item.shareType],
                shareQuantity: item.shareQuantity + item.bonusShareShareQuantity,
                pledgedAmount: item.pledgedAmount,
                investmentStatus: this.translateService.instant(
                  'investment.' + InvestmentStatus[item.investmentStatus],
                ),
                reviewStatus: this.translateService.instant(
                  'shareAllotment.ReviewStatus.' + ReviewStatus[item.reviewStatus],
                ),
                referralCode: item.referralCode || '-',
              };
            });
            this.generateReport(jsonData);
          }

          this.onInvestorListLoaded.emit();
        },
        error: (err) => {
          this.errorService.showError(err);
          console.error(
            'Error in getCampaignInvestorList. isLoading (still true before finalize):',
            this.isLoading,
            err,
          );
        },
      });
  }

  shouldUseShareholderListApi(): boolean {
    return (
      this.storageService.role === Role.IssuerRep &&
      (this.campaign?.campaignStatus === CampaignStatus.ShareAllotment ||
        this.campaign?.campaignStatus === CampaignStatus.Success)
    );
  }

  generateReport(jsonData: Object[]) {
    let fieldNames: FieldKey[] = [
      { key: 'fullName', title: 'Full Name' },
      { key: 'investorType', title: 'Investor Type (Nominees/Direct Investor)' },
      { key: 'pledgedAmount', title: 'Total Invested (RM)' },
      { key: 'createdAt', title: 'Invested Date' },
      { key: 'investmentStatus', title: 'Payment Status' },
      { key: 'shareType', title: 'Type Of Share (OS/RPS)' },
      { key: 'shareQuantity', title: 'Total Share Quantity' },
      { key: 'reviewStatus', title: 'Review Status' },
    ];

    if (this.hasReferralCodes) {
      fieldNames.push({ key: 'referralCode', title: 'Referral Code' });
    }

    this.csvService.downloadFile(
      jsonData,
      fieldNames,
      this.campaign.name + '_Investors_' + moment().format('DD-MM-yyyy'),
    );
  }

  selectedStatuses: InvestmentStatus[] = [];
  selectedReferralCode: ReferralCode[] = [];
  selectedSharetypes: ShareType[] = [];
  selectedReviewStatuses: ReviewStatus[] = [];

  resetShareType() {
    this.selectedSharetypes = [];
    this.filterByShareType();
  }

  isAllShareType(): boolean {
    return this.selectedSharetypes.length === 0;
  }

  toggleAllShareType(event: any) {
    this.isfiltersharetypechanged = true;
    console.log('toggleAllShareType called', event.target.checked);
    if (event.target.checked) {
      this.selectedSharetypes = [];
    } else {
      this.selectedSharetypes = Object.keys(this.ShareType)
        .filter((key) => !isNaN(Number(key)))
        .map((key) => Number(key));
    }
    console.log('selectedStatuses after toggle:', this.selectedSharetypes);
  }

  isShareTypeSelected(shareType: ShareType): boolean {
    return this.selectedSharetypes.includes(shareType);
  }

  toggleShareType(shareType: ShareType, event: any) {
    this.isfiltersharetypechanged = true;
    console.log('toggleShareType called', shareType, event.target.checked);
    if (event.target.checked) {
      this.selectedSharetypes.push(shareType);
    } else {
      this.selectedSharetypes = this.selectedSharetypes.filter((s) => s !== shareType);
    }
    console.log('selectedShareType after toggle:', this.selectedSharetypes);
  }

  filterByShareType() {
    console.log('filterShareType called, selectedStatuses:', this.selectedSharetypes);
    if (this.isfiltersharetypechanged) {
      this.params.currentPage = 1;
    }
    if (this.selectedSharetypes.length === 0) {
      this.params.Types = null;
      console.log('Setting status to null (all statuses)');
    } else {
      this.params.Types = this.selectedSharetypes.join(',') as any; // API might expect a comma-separated string
      console.log('Setting status to:', this.params.Types);
    }
    this.isfiltersharetypechanged = false;
    this.getCampaignInvestorList();
  }

  resetReviewStatus() {
    this.selectedReviewStatuses = this.ReviewStatusEntries.map((s) => s.key);
    this.filterByReviewStatus();
  }

  isAllReviewStatus(): boolean {
    if (this.selectedReviewStatuses.includes(9)) {
      return this.selectedReviewStatuses.length - 1 === this.ReviewStatusEntries.length;
    }
    return this.selectedReviewStatuses.length === this.ReviewStatusEntries.length;
  }

  toggleAllReviewStatus(event: any) {
    this.isFilterReviewStatusChanged = true;
    console.log('toggleAllReviewStatus called', event.target.checked);
    if (event.target.checked) {
      this.selectedReviewStatuses = this.ReviewStatusEntries.map((s) => s.key);
    } else {
      this.selectedReviewStatuses = [];
    }
    console.log('selectedReviewStatuses after toggle:', this.selectedReviewStatuses);
  }

  isReviewStatusSelected(status: ReviewStatus): boolean {
    return this.selectedReviewStatuses.includes(status);
  }

  toggleReviewStatus(status: ReviewStatus, event: any) {
    this.isFilterReviewStatusChanged = true;
    console.log('toggleReviewStatus called', status, event.target.checked);
    if (event.target.checked) {
      this.selectedReviewStatuses.push(status);
    } else {
      this.selectedReviewStatuses = this.selectedReviewStatuses.filter((s) => s !== status);
    }
    console.log('selectedReviewStatuses after toggle:', this.selectedReviewStatuses);
  }

  filterByReviewStatus(shouldFetch: boolean = true) {
    console.log(
      'filterByReviewStatus called, selectedReviewStatuses:',
      this.selectedReviewStatuses,
    );
    if (this.isFilterReviewStatusChanged) {
      this.params.currentPage = 1;
    }
    if (this.selectedReviewStatuses.length === 0) {
      this.selectedReviewStatuses = [9];
    }
    if (this.selectedReviewStatuses.length === this.ReviewStatusEntries.length) {
      this.params.ReviewStatus = null;
      console.log('Setting ReviewStatus to null (all selected)');
    } else {
      this.params.ReviewStatus = this.selectedReviewStatuses.join(',') as any; // API might expect a comma-separated string
      console.log('Setting ReviewStatus to:', this.params.ReviewStatus);
    }
    this.isFilterReviewStatusChanged = false;
    if (shouldFetch) {
      this.getCampaignInvestorList();
    }
  }

  resetstatus() {
    this.selectedStatuses = this.investmentStatusEntries.map((s) => s.key);
    this.filterByStatus();
  }

  isAllStatusesSelected(): boolean {
    if (this.selectedStatuses.includes(9)) {
      return this.selectedStatuses.length - 1 === this.investmentStatusEntries.length;
    }
    return this.selectedStatuses.length === this.investmentStatusEntries.length;
  }

  toggleAllStatuses(event: any) {
    this.isfilterstatuschanged = true;
    console.log('toggleAllStatuses called', event.target.checked);
    if (event.target.checked) {
      this.selectedStatuses = this.investmentStatusEntries.map((s) => s.key);
    } else {
      this.selectedStatuses = [];
    }
    console.log('selectedStatuses after toggle:', this.selectedStatuses);
  }

  isStatusSelected(status: InvestmentStatus): boolean {
    return this.selectedStatuses.includes(status);
  }

  toggleStatus(status: InvestmentStatus, event: any) {
    this.isfilterstatuschanged = true;
    console.log('toggleStatus called', status, event.target.checked);
    if (event.target.checked) {
      this.selectedStatuses.push(status);
    } else {
      this.selectedStatuses = this.selectedStatuses.filter((s) => s !== status);
    }
    console.log('selectedStatuses after toggle:', this.selectedStatuses);
  }

  filterByStatus(shouldFetch: boolean = true) {
    console.log('filterByStatus called, selectedStatuses:', this.selectedStatuses);
    if (this.isfilterstatuschanged) {
      this.params.currentPage = 1;
    }
    if (this.selectedStatuses.length === 0) {
      this.selectedStatuses = [9];
    }
    if (this.selectedStatuses.length === this.investmentStatusEntries.length) {
      this.params.status = null;
      console.log('Setting status to null (all selected)');
    } else {
      this.params.status = this.selectedStatuses.join(',') as any; // API might expect a comma-separated string
      console.log('Setting status to:', this.params.status);
    }
    this.isfilterstatuschanged = false;
    if (shouldFetch) {
      this.getCampaignInvestorList();
    }
  }
  filtermobile() {
    this.filterByStatus(false);
    this.filterByReviewStatus(false);
    this.getCampaignInvestorList();
  }
  resetfiltermobile(event?: any) {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    this.params.currentPage = 1;

    this.selectedStatuses = this.investmentStatusEntries?.map((s) => s.key) ?? [];
    this.params.status = null;
    this.isfilterstatuschanged = false;

    this.selectedReviewStatuses = this.ReviewStatusEntries?.map((s) => s.key) ?? [];
    this.params.ReviewStatus = null;
    this.isFilterReviewStatusChanged = false;

    this.getCampaignInvestorList();
  }

  sortInvestors(sortBy: string) {
    if (this.params.sortBy === sortBy) {
      this.params.sortDirection =
        this.params.sortDirection === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc;
    } else {
      this.params.sortBy = sortBy;
      this.params.sortDirection = SortDirection.Desc;
    }
    this.getCampaignInvestorList();
  }

  checkSortStatus(sortBy: string): number {
    // 1=asc
    // 2=desc
    // 3=default
    if (this.params.sortBy === sortBy) {
      if (this.params.sortBy === 'createdAt') {
        this.sortby = 'sortdate';
      }
      if (this.params.sortBy === 'PledgedAmount') {
        this.sortby = 'sortamount';
      }

      if (this.params.sortDirection === SortDirection.Asc) {
        this.sortdirection = 'sortAsc';
        return 1; // Ascending
      } else if (this.params.sortDirection === SortDirection.Desc) {
        this.sortdirection = 'sortDesc';
        return 2; // Descending
      } else {
        return 3; // Default (no sorting)
      }
    }
  }

  // Function to maintain the original order of enum values in the keyvalue pipe
  keepOriginalOrder = (a: any, b: any): number => {
    console.log('keepOriginalOrder called with:', a, b);
    return 0;
  };

  populateReferralCodeEntries() {
    this.referralCodeEntries = Object.values(ReferralCode)
      .filter((key) => typeof key === 'number' && key !== ReferralCode.All)
      .map((key) => ({
        key: key as number,
        value: ReferralCodeText[key as ReferralCode],
      }));

    console.log('Referral code entries:', this.referralCodeEntries);
  }

  isAllReferralCodeSelected(): boolean {
    return this.selectedReferralCode.length === 0;
  }

  toggleAllReferralCode(event: any) {
    this.isfilterreferralCodechanged = true;
    console.log('toggleAllReferralCode called', event.target.checked);

    if (event.target.checked) {
      this.selectedReferralCode = [];
    } else {
      this.selectedReferralCode = [ReferralCode.Yes, ReferralCode.No];
    }

    console.log('selectedReferralCode after toggle:', this.selectedReferralCode);
  }

  isReferralCodeSelected(referralCode: ReferralCode): boolean {
    return this.selectedReferralCode.includes(referralCode);
  }

  toggleReferralCode(referralCode: ReferralCode, event: any) {
    this.isfilterreferralCodechanged = true;
    console.log('toggleStatus called', referralCode, event.target.checked);
    if (event.target.checked) {
      this.selectedReferralCode.push(referralCode);
    } else {
      this.selectedReferralCode = this.selectedReferralCode.filter((s) => s !== referralCode);
    }
    console.log('selectedReferralCode after toggle:', this.selectedReferralCode);
  }

  filterByReferralCode() {
    console.log('filterByReferralCode called, selectedReferralCode:', this.selectedReferralCode);
    if (this.isfilterreferralCodechanged) {
      this.params.currentPage = 1;
    }

    if (this.selectedReferralCode.length === 0) {
      this.params.referralCode = null;
      console.log('Setting referralCode to null (all referralCode)');
    } else if (this.selectedReferralCode.length === 2) {
      this.params.referralCode = null;
      console.log('Setting referralCode to null (both Yes and No selected)');
    } else {
      this.params.referralCode = this.selectedReferralCode.join(',');
      console.log('Setting referralCode to:', this.params.referralCode);
    }

    this.isfilterreferralCodechanged = false;
    this.getCampaignInvestorList();
  }

  resetReferralCode() {
    this.selectedReferralCode = [];
    this.filterByReferralCode();
  }

  filterByPaymentType() {
    console.log('Selected Payment Type:', this.selectedPaymentType);
    this.params.currentPage = 1;
    if (this.selectedPaymentType === '0') {
      this.params.PaymentTo = null;
    } else {
      this.params.PaymentTo = this.selectedPaymentType;
    }
    this.getCampaignInvestorList();
  }

  filterByReferral() {
    console.log('Selected Referral:', this.selectedRefferal);
    this.params.currentPage = 1;
    if (this.selectedRefferal === '0') {
      this.params.referralCode = null;
    } else {
      this.params.referralCode = this.selectedRefferal;
    }
    this.getCampaignInvestorList();
  }

  resetPaymentTypeFilter() {
    this.selectedPaymentType = '0';
    this.filterByPaymentType();
  }

  resetReferralFilter() {
    this.selectedRefferal = '0';
    this.filterByReferral();
  }

  resetSorting() {
    this.params.sortBy = 'createdAt';
    this.params.sortDirection = SortDirection.Desc;
    this.sortby = undefined;
    this.sortdirection = undefined;
  }
  resetAllFilters(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.params.currentPage = 1;
    this.resetSorting();
    this.searchName = '';
    this.params.InvestorName = '';

    this.selectedPaymentType = '0';
    this.params.PaymentTo = null;

    this.selectedRefferal = '0';
    this.selectedReferralCode = [];
    this.params.referralCode = null;

    this.selectedSharetypes = [];
    this.params.Types = null;
    this.isfiltersharetypechanged = false;

    this.selectedReviewStatuses = this.ReviewStatusEntries?.map((s) => s.key) ?? [];
    this.params.ReviewStatus = null;
    this.isFilterReviewStatusChanged = false;

    this.selectedStatuses = this.investmentStatusEntries.map((s) => s.key);
    this.params.status = null;
    this.isfilterstatuschanged = false;

    this.getCampaignInvestorList();
  }

  applyAllFilters() {
    this.filterByStatus();
    this.filterByReferralCode();
  }

  getStatusClass(status: number): string {
    switch (status) {
      case 1:
        return 'pendingpaymentstatus';
      case 2:
        return 'paidstatus';
      case 3:
        return 'cancelstatus';
      case 4:
        return 'refundedstatus';
      case 5:
        return 'requestrefundstatus';
      case 6:
        return 'pendingapprovalstatus';
      case 7:
        return 'completedstatus';
      default:
        return '';
    }
  }

  getShareAllotmentStatusClass(status: number): string {
    switch (status) {
      case 1:
        return 'pendingpaymentstatus';
      case 2:
        return 'paidstatus';
      case 3:
        return 'completedstatus';
      default:
        return '';
    }
  }

  getReviewStatusClass(status: number): string {
    switch (status) {
      case 1:
        return 'pendingReviewstatus';
      case 2:
        return 'paidstatus';
      case 3:
        return 'completedstatus';
      case 4:
        return 'awaitingRevisionstatus';
      case 5:
        return 'requestrefundstatus';
      default:
        return '';
    }
  }

  private getShareIdForShareReview(investment: InvestmentModel): number | null {
    const anyInvestment = investment as any;
    const shareId = anyInvestment?.shareId ?? anyInvestment?.share?.id ?? investment?.id;
    return typeof shareId === 'number' && !isNaN(shareId) ? shareId : null;
  }

  private getExistingShareReviewRequestRemark(investment: InvestmentModel): string {
    const anyInvestment = investment as any;
    const remark =
      anyInvestment?.reviewRequest?.remarks ??
      anyInvestment?.reviewRequestRemarks ??
      anyInvestment?.reviewRequestRemark ??
      anyInvestment?.reviewRequest?.remark ??
      anyInvestment?.remarks ??
      '';
    return (remark ?? '').toString();
  }

  private hasExistingShareReviewRequest(investment: InvestmentModel): boolean {
    const anyInvestment = investment as any;
    if (anyInvestment?.reviewRequestId || anyInvestment?.reviewRequest?.id) return true;

    const remark = this.getExistingShareReviewRequestRemark(investment);
    if (remark && remark.trim().length > 0) return true;

    return (
      investment?.reviewStatus === ReviewStatus.AwaitingRevision ||
      investment?.reviewStatus === ReviewStatus.Revised
    );
  }

  isApproveShareReviewDisabled(investment: InvestmentModel): boolean {
    if (!this.campaign) return true;
    if (this.campaign.campaignStatus !== CampaignStatus.ShareAllotment) return true;
    if (this.storageService.role !== Role.IssuerRep) return true;
    if (investment?.reviewStatus === ReviewStatus.Approved) return true;

    const shareId = this.getShareIdForShareReview(investment);
    if (!shareId) return true;
    return this.approvingShareReviewIds.has(shareId);
  }

  approveShareReview(investment: InvestmentModel) {
    const shareholderRowId = this.getShareIdForShareReview(investment);
    if (!shareholderRowId) {
      this.snackBar.open('Unable to approve: missing share id.', '', { duration: 2500 });
      return;
    }

    if (investment.reviewStatus === ReviewStatus.Approved) {
      this.toastService.success(this.translateService.instant('toast.investorApproved'));
      return;
    }

    this.approvingShareReviewIds.add(shareholderRowId);

    this.campaignService
      .approveShareReview(this.campaign.id, shareholderRowId)
      .pipe(
        finalize(() => {
          this.approvingShareReviewIds.delete(shareholderRowId);
        }),
      )
      .subscribe({
        next: (updatedCount) => {
          investment.reviewStatus = ReviewStatus.Approved;
          const suffix =
            typeof updatedCount === 'number' && updatedCount > 1
              ? ` (${updatedCount} updated)`
              : '';
          this.toastService.success(`Investor approved${suffix}`);
          this.reviewStatusUpdated.emit();
          this.getCampaignInvestorList();
        },
        error: (err) => {
          this.errorService.showError(err);
        },
      });
  }

  openPurpleEditPopup(investment: InvestmentModel) {
    if (!this.campaign) return;

    const shareId = this.getShareIdForShareReview(investment);
    if (!shareId) {
      this.snackBar.open('Unable to submit: missing share id.', '', { duration: 2500 });
      return;
    }

    const popupOptions: NgbModalOptions = {
      size: 'md',
      centered: true,
      keyboard: false,
      backdrop: 'static',
      windowClass: 'purple-edit-modal',
    };

    const modalRef = this.modalService.open(ShareReviewEditPopupComponent, popupOptions);
    modalRef.componentInstance.investment = investment;
    modalRef.componentInstance.campaignId = this.campaign.id;
    modalRef.componentInstance.shareId = shareId;
    modalRef.componentInstance.isEditMode = this.hasExistingShareReviewRequest(investment);

    const existingRemark = this.getExistingShareReviewRequestRemark(investment);
    if (existingRemark) {
      modalRef.componentInstance.remark = existingRemark;
    }

    modalRef.result.then(
      (refresh: boolean) => {
        if (refresh) {
          this.reviewStatusUpdated.emit();
          this.getCampaignInvestorList();
        }
      },
      () => {},
    );
  }

  private getSelectableShareReviewIdsOnPage(): number[] {
    if (!this.investments || this.investments.length === 0) return [];

    const ids: number[] = [];
    for (const inv of this.investments) {
      if (this.isApproveShareReviewDisabled(inv)) continue;
      const shareId = this.getShareIdForShareReview(inv);
      if (shareId) ids.push(shareId);
    }
    return ids;
  }

  get selectedShareReviewCount(): number {
    return this.selectedShareReviewIds.size;
  }

  get selectableShareReviewCount(): number {
    return this.getSelectableShareReviewIdsOnPage().length;
  }

  private clearReviewSelection() {
    this.selectedShareReviewIds.clear();
  }

  bulkApproveSelectedShareReview() {
    if (!this.campaign) return;
    if (this.campaign.campaignStatus !== CampaignStatus.ShareAllotment) return;
    if (this.storageService.role !== Role.IssuerRep) return;

    const selectedIds = Array.from(this.selectedShareReviewIds);
    const selectedEligibleIds = selectedIds.filter((shareId) => {
      const investment = this.investments?.find(
        (inv) => this.getShareIdForShareReview(inv) === shareId,
      );
      if (!investment) return false;
      return investment.reviewStatus !== ReviewStatus.Approved;
    });

    if (selectedEligibleIds.length === 0) {
      this.snackBar.open('No pending review shares selected.', '', { duration: 2000 });
      return;
    }

    this.bulkApprovingShareReview = true;
    selectedEligibleIds.forEach((id) => this.approvingShareReviewIds.add(id));

    this.campaignService
      .bulkApproveShareReview(this.campaign.id, selectedEligibleIds)
      .pipe(
        finalize(() => {
          selectedEligibleIds.forEach((id) => this.approvingShareReviewIds.delete(id));
          this.bulkApprovingShareReview = false;
          this.clearReviewSelection();
        }),
      )
      .subscribe({
        next: (updatedCount) => {
          const updated =
            typeof updatedCount === 'number' && !isNaN(updatedCount)
              ? updatedCount
              : selectedEligibleIds.length;
          const suffix = updated > 1 ? ` (${updated} updated)` : '';
          this.toastService.success(`Investor approved${suffix}`);
          this.reviewStatusUpdated.emit();
          this.getCampaignInvestorList();
        },
        error: (err) => {
          this.errorService.showError(err);
        },
      });
  }

  filterByName() {
    this.params.InvestorName = this.searchName.trim();
    this.params.currentPage = 1;
    this.getCampaignInvestorList();
  }

  resetnamefilter() {
    this.params.InvestorName = '';
    this.searchName = '';
    this.filterByName();
  }
  get totalPages(): number {
    return Math.ceil(this.total / this.params.take);
  }

  getInvestorRowNumber(indexOnPage: number): number {
    const base = this.currentitem > 0 ? this.currentitem : 1;
    return base + indexOnPage;
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.params.currentPage = page;
      this.getCampaignInvestorList();
    }
  }
  copyReferralCode(code: string) {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        this.copiedCode = code;
        this.snackBar.open('Referral code copied!', '', { duration: 1200 });

        // Reset visual feedback after 1s
        setTimeout(() => {
          this.copiedCode = null;
        }, 1000);
      })
      .catch((err) => console.error('Failed to copy referral code: ', err));
  }

  isSelected(investment: InvestmentModel): boolean {
    const shareId = this.getShareIdForShareReview(investment);
    if (!shareId) return false;
    return this.selectedShareReviewIds.has(shareId);
  }

  toggleRow(investment: InvestmentModel, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    const shareId = this.getShareIdForShareReview(investment);
    if (!shareId) return;
    if (this.isApproveShareReviewDisabled(investment)) return;

    if (checked) {
      this.selectedShareReviewIds.add(shareId);
    } else {
      this.selectedShareReviewIds.delete(shareId);
    }
  }

  toggleSelectAll(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      this.getSelectableShareReviewIdsOnPage().forEach((id) => this.selectedShareReviewIds.add(id));
    } else {
      this.clearReviewSelection();
    }
  }
  toggleMobileSelectAll() {
    const allSelected = this.isAllSelected();
    if (allSelected) {
      this.clearReviewSelection();
      return;
    }
    this.getSelectableShareReviewIdsOnPage().forEach((id) => this.selectedShareReviewIds.add(id));
  }

  isAllSelected(): boolean {
    const selectableCount = this.selectableShareReviewCount;
    return selectableCount > 0 && this.selectedShareReviewIds.size === selectableCount;
  }

  isIndeterminate(): boolean {
    const selectableCount = this.selectableShareReviewCount;
    return (
      this.selectedShareReviewIds.size > 0 && this.selectedShareReviewIds.size < selectableCount
    );
  }

  trackById(index: number, item: any) {
    return item.id;
  }
}
